import LiveInputsService from '@app/application/reconciliation/services/live-inputs-service'
import { SfLog } from '@app/adapters/logger'

onDomLoad(($dom) => {
  $dom[0]
    .querySelectorAll(
      "[data-behaviour='account-selector-modal'], [data-behaviour='external-account-selector-modal']"
    )
    .forEach((el) => {
      el.addEventListener('click', () => {
        const {
          name,
          objectId,
          objectType,
          objectLedgerId,
          range,
          value,
          defaultValue,
          valueType,
          externalCompanyId,
        } = el.dataset

        const external =
          el.dataset.behaviour === 'external-account-selector-modal'

        const parent = el.closest('[data-behaviour="live-inputs"]')
        const parentdataset = parent.dataset

        const updatePath = parentdataset.createPropertiesPath
        const ownerType = parentdataset.ownerType
        const ownerId = parseInt(parentdataset.ownerId)
        const ledgerId = parseInt(parentdataset.ledgerId)

        const ledgerLabel = document.getElementById('ledger-label')?.innerHTML

        const liveInputsService = LiveInputsService()

        if (!liveInputsService.instance) {
          SfLog.info('LiveInputs::Missing LiveInputs instance', {
            extra: {
              ...window.Silverfin.jsonParams,
            },
          })
          return
        }

        const dataToSubmit = liveInputsService.instance.dataToSubmit
        const updateParams = {
          ledgerId,
          name,
          objectId: parseInt(objectId),
          objectType,
          objectLedgerId: parseInt(objectLedgerId),
          valueType,
          [ownerType]: ownerId,
        }

        const modalParams = {
          ...updateParams,
          dataToSubmit: dataToSubmit,
          attemptToConfirmUnreview: parentdataset.attemptToConfirmUnreview,
          range,
          value,
          defaultValue,
          updatePath,
          external,
          ledgerLabel,
          externalCompanyId,
          afterUpdate: (response) => {
            liveInputsService.instance.replaceHtml(response)
            liveInputsService.instance.liveValidationHandlers.forEach(
              (handler) => handler()
            )
            liveInputsService.instance.showUndo(response.auditIds)
            liveInputsService.instance.clearDataToSubmit()
          },
        }

        window.modalCitizen.openModal('account-selector-modal', modalParams)
      })
    })
})
